import RepositoryFactory from '@/repository/RepositoryFactory';
import { showErrorNotification } from '@/util';
import {
  FLAG_ON,
  MAX_RECORDS_IN_PAGE,
  OPEN_FLAG_OPEN,
  OPEN_FLAG_CLOSE,
  CATEGORY_KIND_GROUP_GROUP,
  RECORDS_IN_PAGE_PARAMETER_NAME,
} from '@/constant';
// const categoriesRepository = RepositoryFactory.shiftService.absenceCategories;

/**
 * グループ情報を取得
 * @param serviceId 園ID
 * @param search_kind 検索種別
 * @param is_all 全ての情報を取得するかどうか
 */
const getGroups = async function (getGroupsParams: any) {
  const { serviceId, is_all, notify, state } = getGroupsParams;

  let params: any = {};
  params.search_serviceId = serviceId || null;
  params.search_open_flag = !is_all ? OPEN_FLAG_OPEN : OPEN_FLAG_CLOSE;
  params[RECORDS_IN_PAGE_PARAMETER_NAME] = MAX_RECORDS_IN_PAGE;

  //   const fetchedCategories = await categoriesRepository.index();
  const fetchedCategories = {
    data: [],
  };

  return fetchedCategories.data
    .map((category: any) => {
      if (category && category.groups && Number(category.kind) === CATEGORY_KIND_GROUP_GROUP) {
        let groupObj: any = {};
        groupObj.id = category.id;
        groupObj.type = category.name;
        groupObj.open_flag = category.open_flag;
        groupObj.report_flag = category.report_flag;
        groupObj.data = category.groups
          .map((value: any) => {
            return { id: value.id, name: value.name, open_flag: value.open_flag, kind: value.kind };
          })
          .filter((groupObj: any) => is_all || groupObj.open_flag == FLAG_ON.toString());
        return groupObj;
      }
    })
    .filter((categoryGroup: any) => categoryGroup && categoryGroup !== undefined);
};

export default getGroups;
